import { render, staticRenderFns } from "./OidcCallback.vue?vue&type=template&id=79b0a956"
import script from "./OidcCallback.vue?vue&type=script&lang=ts"
export * from "./OidcCallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b0a956')) {
      api.createRecord('79b0a956', component.options)
    } else {
      api.reload('79b0a956', component.options)
    }
    module.hot.accept("./OidcCallback.vue?vue&type=template&id=79b0a956", function () {
      api.rerender('79b0a956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/authentication/OIDC/OidcCallback.vue"
export default component.exports